let promise;

module.exports = async function loadScript() {
  if (!window.CAPTCHA_ID) return;

  if (promise) return promise;

  promise = new Promise((resolve, reject) => {
    window.captchaCallback = resolve;
    let script = document.createElement('script');
    script.src = window.CAPTCHA_TYPE == 'recaptcha' ? 
      `https://www.google.com/recaptcha/api.js?onload=captchaCallback&render=explicit` : 
      `https://smartcaptcha.yandexcloud.net/captcha.js?render=onload&onload=captchaCallback`;
    script.onerror = reject;
    document.head.appendChild(script);
  });

  return promise;
}

